import { render, staticRenderFns } from "./StoreOpenInquireManagerEdit.vue?vue&type=template&id=0825adab&"
import script from "./StoreOpenInquireManagerEdit.vue?vue&type=script&lang=js&"
export * from "./StoreOpenInquireManagerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports